import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

/**
 * exists only as cycle-breaking service.
 */
@Injectable()
export class ClientAccountIsTradableService {
  protected accountSubject = new Subject<{
    isTradable: boolean;
    wasTradable: boolean;
    id: string;
  }>();
  protected clientSubject = new Subject<{
    isTradable: boolean;
    wasTradable: boolean;
    clientId: string;
  }>();

  public account$ = this.accountSubject.asObservable();
  public client$ = this.clientSubject.asObservable();
}
